var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerCream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.41 49.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #f4efe5;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 10.22,
    height: 10.22,
    rx: 3.03,
    ry: 3.03,
    transform: "translate(12.22 0) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 19.53,
    width: 10.22,
    height: 10.22,
    rx: 3.03,
    ry: 3.03,
    transform: "translate(30.75 18.53) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 38.05,
    width: 10.22,
    height: 10.22,
    rx: 3.03,
    ry: 3.03,
    transform: "translate(49.28 37.05) rotate(90)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.87,43.16h5.44c1.26,0,2.27-1.02,2.27-2.27V8.38c0-1.26-1.02-2.27-2.27-2.27h-5.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.87,
    y1: 24.64,
    x2: 30.54,
    y2: 24.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.54,
    y: 16.2,
    width: 16.87,
    height: 16.87,
    rx: 3.74,
    ry: 3.74
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerCream);
export default __webpack_public_path__ + "static/media/partner-cream.14ea2cb4140f4620bc313e7be25ca7fc.svg";
export { ForwardRef as ReactComponent };